export default __webpack_public_path__ + "static/Stop-Vaping-7091022dd8e7e4c21ed66df5f2777f61.webp";